import { api } from './client';

export const storiesApi = {
  list: (projectId) => api.get(`/projects/${projectId}/stories`),

  get: (storyId, options) => api.get(`/stories/${storyId}`, options),

  create: (projectId, data) => api.post(`/projects/${projectId}/stories`, data),

  // Find-or-create the story's Discovery session (book-discovery-navigation
  // unit). Idempotent — safe to call every time the writer enters a book.
  ensureDiscoverySession: (storyId) => api.post(`/stories/${storyId}/discovery-session`),

  update: (storyId, data) => api.patch(`/stories/${storyId}`, data),

  delete: (storyId) => api.delete(`/stories/${storyId}`),

  // Session Branching: Session tree for story
  /**
   * Get session tree for a story
   * Returns all sessions belonging to the story plus ancestral project sessions
   * @param {string} storyId - Story UUID
   * @returns {Promise<Object>} { data: { nodes: [...] } }
   */
  getSessionTree: (storyId) => api.get(`/stories/${storyId}/session-tree`),

  /** Read-only Story progress lanes (#2075). No paid call.
   *  no-store: a Note save rereads this, and a cached copy would stay old.
   */
  getStoryProgress: (storyId, options = {}) => api.get(
    `/stories/${storyId}/story-progress`,
    { ...options, cache: 'no-store' },
  ),

  /** Staging label for the context-order switch (#2131). Null on the old order and on production. */
  getContextOrder: (storyId) => api.get(`/stories/${storyId}/context-order`),
};
